import React, { useEffect, useState, Children } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';
const slides = [{
  id: 1,
  image: 'https://cdn.magicpatterns.com/uploads/kT5XfZgjwAS6LgTyP6B8dW/pexels-mingao-welfarecar-555708794-18247486.jpg',
  alt: 'Wheelchair accessible van with deployed seat',
  title: 'Accessible Transportation'
}, {
  id: 2,
  image: 'https://cdn.magicpatterns.com/uploads/d5zXDrhBCX1EnU4dT6JqNq/pexels-yankrukov-8617515.jpg',
  alt: 'Children being picked up for school run',
  title: 'Safe School Runs'
}, {
  id: 3,
  image: 'https://cdn.magicpatterns.com/uploads/urSJUvcKdrT6UkVocdyLED/william-william-NndKt2kF1L4-unsplash.jpg',
  alt: 'Container ship at port with cargo containers',
  title: 'Reliable Shipping'
}];
export function MobileHeroSlider() {
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex(prevIndex => (prevIndex + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);
  const nextSlide = () => {
    setCurrentIndex(prevIndex => (prevIndex + 1) % slides.length);
  };
  const prevSlide = () => {
    setCurrentIndex(prevIndex => (prevIndex - 1 + slides.length) % slides.length);
  };
  return <div className="relative w-full h-[298px] sm:h-[383px] lg:hidden overflow-hidden bg-warm-50" data-id="element-137">
      <AnimatePresence initial={false} data-id="element-138">
        <motion.img key={currentIndex} src={slides[currentIndex].image} alt={slides[currentIndex].alt} initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.5
      }} className="absolute inset-0 w-full h-full object-cover" data-id="element-139" />
      </AnimatePresence>

      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" data-id="element-140" />

      {/* Content */}
      <div className="absolute bottom-0 left-0 right-0 p-6 text-white" data-id="element-141">
        <AnimatePresence mode="wait" data-id="element-142">
          <motion.h2 key={currentIndex} initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -10
        }} transition={{
          duration: 0.3
        }} className="text-2xl font-bold mb-2" data-id="element-143">
            {slides[currentIndex].title}
          </motion.h2>
        </AnimatePresence>

        {/* Indicators */}
        <div className="flex gap-2 mt-4" data-id="element-144">
          {slides.map((_, index) => <button key={index} onClick={() => setCurrentIndex(index)} className={`h-1.5 rounded-full transition-all duration-300 ${index === currentIndex ? 'w-8 bg-primary-500' : 'w-4 bg-white/50'}`} aria-label={`Go to slide ${index + 1}`} data-id="element-145" />)}
        </div>
      </div>

      {/* Navigation Arrows */}
      <button onClick={prevSlide} className="absolute left-2 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center rounded-full bg-black/30 text-white backdrop-blur-sm hover:bg-black/50 transition-colors" aria-label="Previous slide" data-id="element-146">
        <ChevronLeft className="w-6 h-6" data-id="element-147" />
      </button>
      <button onClick={nextSlide} className="absolute right-2 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center rounded-full bg-black/30 text-white backdrop-blur-sm hover:bg-black/50 transition-colors" aria-label="Next slide" data-id="element-148">
        <ChevronRight className="w-6 h-6" data-id="element-149" />
      </button>
    </div>;
}